import React, { useState } from "react";

import Button from "react-bootstrap/Button";
import Stack from "react-bootstrap/Stack";
import Card from "react-bootstrap/Card";

import { InfoCard } from "../InfoCard";
import { Report } from "./Report";
import { EmptyContainer } from "../../EmptyContainer";
import { DeleteModal } from "../../DeleteModal";

export default function Reports({
  reports,
  handleClick,
  isRemoving,
  removeReport,
  hasEventEnded,
}) {
  const [show, setShow] = useState(false);

  // id to remove
  const [id, setId] = useState();

  const handleShow = (id) => {
    setShow(true);
    setId(id);
  };

  const handleClose = () => {
    setShow(false);
    setId();
  };

  const handleDelete = () => {
    removeReport(id).then(() => {
      handleClose();
    });
  };

  return (
    <>
      <Stack direction="horizontal" className="mb-5">
        <Button
          size="lg"
          variant="outline-light"
          className="btn-plus ms-auto"
          onClick={handleClick}
          disabled={hasEventEnded}
        >
          Add recipient
        </Button>
      </Stack>
      <InfoCard />
      <Card body>
        {reports && reports.length > 0 ? (
          <div className="list-table">
            <div className="flex-row list-table-header" role="rowgroup">
              <div
                className="list-table-col list-table-col-header lg"
                role="columnheader"
              >
                <span>Emails</span>
              </div>
            </div>
            {reports.map((report, index) => (
              <Report
                key={index}
                report={report}
                handleShow={handleShow}
                handleClick={handleClick}
              />
            ))}
          </div>
        ) : (
          <EmptyContainer>
            <p>
              Nothing is scheduled, click Add recipient to schedule a daily
              ticket count to be sent.
            </p>
          </EmptyContainer>
        )}
      </Card>
      <DeleteModal
        entity="recipient"
        show={show}
        handleClose={handleClose}
        isRemoving={isRemoving}
        handleDelete={handleDelete}
      />
    </>
  );
}
